// @flow
import React from 'react';

import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink.jsx';

export function FooterAnnexes({
  className,
  items = [],
}: {
  className?: string,
  items: CMSFooterAnnexes,
}) {
  return (
    <div className={className}>
      <ul className="reset-list mb-5 -mx-2">
        {items.map(({ label, links }) => (
          <li
            className="align-top inline-block mb-5 px-2 w-1/3"
            data-testid="FooterAnnexesItem"
            key={label}
          >
            <p
              aria-level="2"
              className="reset-paragraph font-bold leading-one mb-2 text-sm uppercase"
              data-testid="FooterAnnexesHeading"
              role="heading"
            >
              {label}
            </p>
            <ul className="reset-list">
              {links.map(link => (
                <li className="leading-loose mb-1 text-sm" key={link.label}>
                  <DynamicLink
                    className="inline-block leading-one text-inherit focus:text-gray-light hover:text-gray-light transition-color"
                    target="_blank"
                    url={link.href}
                  >
                    {link.label}
                  </DynamicLink>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </div>
  );
}
